const SignInOrSinUpBasicParams = {
    from: 'online',
    isEnterp: 1,
    an: 'Foxit PhantomPDF Online',
    av: '3.0.0.1',
    cv: '2.0.0.0',
}

export function genSignInOrSignUpBasicParams(cTag = 'WebPage') {
    return Object.assign({
        cTag
    }, SignInOrSinUpBasicParams);
}
